import productExceptions from './productExceptions';
import user from './user';
import maxDiscounts from './maxDiscounts';
import minMargins from './minMargins';
import pricingRules from './pricingRules';
import pricingRulesVp from './pricingRulesVp';
import business from './business';
import topNCategories from './topNCategories';
import products from './products';
import productsVp from './productsVp';
import dashboard from './dashboard';
import configuration from './configuration';

export const productExceptionsApi = productExceptions;
export const maxDiscountsApi = maxDiscounts;
export const userApi = user;
export const minMarginsApi = minMargins;
export const pricingRulesApi = pricingRules;
export const pricingRulesVpApi = pricingRulesVp;
export const businessApi = business;
export const topNCategoriesApi = topNCategories;
export const dashboardApi = dashboard;
export const productsApi = products;
export const productsVpApi = productsVp;
export const configurationApi = configuration;
